const getAlbumRestrictedAttributes = (locale: string): string[] => {
	let countryCode = locale.substring(3)
	const attributes = [
		'Album.Genre',
		'Album.SubGenre',
		'MusicalStyles',
		'Moods',
		'Title',
		'Instrumentations',
		'ProductionGenres',
		'Toolkit',
		'TempoName',
		'Album.Name',
		'Album.Artists',
		'Composers.FirstName',
		'Composers.LastName',
		'OriginalComposer',
		'MixType',
		'Eras',
		'AlbumTrackAliases',
		'TrackFilenames',
	]

	if (countryCode != 'GB' && countryCode != 'US' && countryCode != 'AU') {
		countryCode = countryCode[0] + countryCode[1].toLowerCase()
		attributes.push(
			`MusicalStyles_${countryCode}`,
			`Moods_${countryCode}`,
			`Instrumentations_${countryCode}`,
			`ProductionGenres_${countryCode}`,
			`Toolkit_${countryCode}`,
			`TempoName_${countryCode}`,
			`Album.Genre_${countryCode}`,
			`Album.SubGenre_${countryCode}`
		)
	}
	return attributes
}

export { getAlbumRestrictedAttributes }
